(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const grid = document.querySelector('.product-grid');
    if (!grid) return;

    const lastPage = parseInt(grid.dataset.lastPage || '1', 10);

    function maxPageLoaded() {
      let max = 1;
      for (const el of grid.children) {
        const p = parseInt(el.dataset.page, 10);
        if (p > max) max = p;
      }
      return max;
    }

    function sortOOS() {
      Array.from(grid.children)
        .filter(el => el.dataset.available === 'false')
        .forEach(el => grid.appendChild(el));
    }

    // Single page or all pages already present: sort immediately.
    if (lastPage <= 1 || maxPageLoaded() >= lastPage) {
      sortOOS();
      return;
    }

    // Multi-page: wait until the last page's items land in the grid, then
    // move every OOS item to the end in one synchronous batch (fires as a
    // microtask, before the browser paints, so the shuffle is invisible).
    const observer = new MutationObserver(mutations => {
      const hasCards = mutations.some(m =>
        Array.from(m.addedNodes).some(
          n => n.nodeType === 1 && n.dataset && 'available' in n.dataset
        )
      );
      if (!hasCards) return;
      if (maxPageLoaded() >= lastPage) {
        observer.disconnect();
        sortOOS();
      }
    });

    observer.observe(grid, { childList: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
  (function () {
    var burger   = document.getElementById('mobile-nav-burger');
    var drawer   = document.getElementById('mobile-nav-drawer');
    var backdrop = document.getElementById('mobile-nav-backdrop');
    var closeBtn = document.getElementById('mobile-nav-close');
    var tabs     = document.getElementById('mobile-nav-tabs');
    var searchInput = drawer && drawer.querySelector('.mobile-nav__search-input');
    var searchClear = document.getElementById('mobile-nav-search-clear');

    if (!burger || !drawer) return;

    /* ── sync burger height to actual header ─────────── */
    function syncBurgerHeight() {
      var headerEl = document.querySelector('#header-group header-component, #header-group header');
      var h = headerEl ? headerEl.offsetHeight : 0;
      /* transparent/absolute headers may report 0 — fall back to CSS variable */
      if (h > 10) burger.style.height = h + 'px';
      else burger.style.height = (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 60) + 'px';
    }
    syncBurgerHeight();
    window.addEventListener('resize', syncBurgerHeight);
    if (window.ResizeObserver) {
      var headerEl = document.querySelector('#header-group header-component, #header-group header');
      if (headerEl) new ResizeObserver(syncBurgerHeight).observe(headerEl);
    }

    var isOpen     = false;
    var activeTab  = 'primary';
    var activePanels = { primary: 'primary-main', secondary: 'secondary-main' };

    /* ── helpers ─────────────────────────────────────── */
    function getPanel(id) {
      return drawer.querySelector('[data-panel="' + id + '"]');
    }
    function getTabPanels(tab) {
      return drawer.querySelector('[data-tab-panels="' + tab + '"]');
    }

    /* ── open/close ──────────────────────────────────── */
    function open() {
      isOpen = true;
      drawer.classList.add('mobile-nav__drawer--open');
      backdrop.classList.add('mobile-nav__backdrop--visible');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      isOpen = false;
      drawer.classList.remove('mobile-nav__drawer--open');
      backdrop.classList.remove('mobile-nav__backdrop--visible');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () { resetAll(); }, 360);
    }

    /* ── panel navigation ────────────────────────────── */
    function openPanel(id) {
      var tab    = id.split('-')[0];
      var main   = getPanel(tab + '-main');
      var next   = getPanel(id);
      if (!next || activePanels[tab] === id) return;

      main.classList.add('mobile-nav__panel--pushed');
      main.classList.remove('mobile-nav__panel--active');

      next.style.transition = 'none';
      next.style.transform  = 'translateX(100%)';
      next.offsetHeight;
      next.style.transition = '';
      next.classList.add('mobile-nav__panel--active');

      activePanels[tab] = id;
    }

    function goBack(panelId) {
      var tab     = panelId.split('-')[0];
      var main    = getPanel(tab + '-main');
      var current = getPanel(activePanels[tab]);
      if (!current || activePanels[tab] === panelId) return;

      current.classList.remove('mobile-nav__panel--active');
      current.style.transform = 'translateX(100%)';

      main.classList.remove('mobile-nav__panel--pushed');
      main.classList.add('mobile-nav__panel--active');

      activePanels[tab] = panelId;
    }

    /* ── tab switching ───────────────────────────────── */
    function switchTab(tab) {
      if (tab === activeTab) return;

      var oldPanels = getTabPanels(activeTab);
      var newPanels = getTabPanels(tab);
      if (oldPanels) oldPanels.classList.remove('mobile-nav__tab-panels--active');
      if (newPanels) newPanels.classList.add('mobile-nav__tab-panels--active');

      if (tabs) {
        tabs.querySelectorAll('.mobile-nav__tab').forEach(function (t) {
          t.classList.toggle('mobile-nav__tab--active', t.getAttribute('data-tab') === tab);
        });
      }

      activeTab = tab;
    }

    /* ── reset all panels to initial state ───────────── */
    function resetAll() {
      drawer.querySelectorAll('.mobile-nav__panel').forEach(function (p) {
        p.classList.remove('mobile-nav__panel--active', 'mobile-nav__panel--pushed');
        p.style.transform  = '';
        p.style.transition = '';
      });
      drawer.querySelectorAll('[data-panel$="-main"]').forEach(function (p) {
        p.classList.add('mobile-nav__panel--active');
      });
      activePanels = { primary: 'primary-main', secondary: 'secondary-main' };
      switchTab('primary');
    }

    /* ── search clear ────────────────────────────────── */
    if (searchInput && searchClear) {
      searchInput.addEventListener('input', function () {
        searchClear.classList.toggle('mobile-nav__search-clear--visible', searchInput.value.length > 0);
      });
      searchClear.addEventListener('click', function () {
        searchInput.value = '';
        searchClear.classList.remove('mobile-nav__search-clear--visible');
        searchInput.focus();
      });
    }

    /* ── events ──────────────────────────────────────── */
    burger.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);

    drawer.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-open-panel]');
      var backBtn = e.target.closest('[data-back]');
      var tabBtn  = e.target.closest('[data-tab]');

      if (openBtn) openPanel(openBtn.getAttribute('data-open-panel'));
      if (backBtn) goBack(backBtn.getAttribute('data-back'));
      if (tabBtn)  switchTab(tabBtn.getAttribute('data-tab'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-secondary-nav"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shop-secondary-nav__toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.shop-secondary-nav__toggle').forEach(function(t) {
        t.setAttribute('aria-expanded', 'false');
      });
      this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.shop-secondary-nav__item--has-dropdown')) {
      document.querySelectorAll('.shop-secondary-nav__toggle').forEach(function(t) {
        t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
